import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import { cn } from "../../utils";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../collapsible";
import GameFilterPills from "./GameFilterPills";
import type { GameFilterGroup as Group } from "./types";

type Props = {
  group: Group;
  defaultOpen?: boolean;
  onSelect: (value: string | undefined) => void;
};

const GameFilterGroup: FC<Props> = ({ group, defaultOpen, onSelect }) => (
  <Collapsible
    defaultOpen={defaultOpen}
    data-slot="game-filter-group"
    data-testid={`game-filter-group-${group.id}`}
    className="overflow-hidden rounded-xl bg-secondary"
  >
    <CollapsibleTrigger className="group flex h-12 w-full cursor-pointer items-center justify-between gap-3 px-3">
      <span className="text-sm font-semibold text-foreground">
        {group.title}
      </span>
      <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-background text-muted-foreground transition-colors group-hover:text-foreground">
        <HugeiconsIcon
          icon={ArrowDown01Icon}
          className={cn(
            "size-4 transition-transform duration-150",
            "group-data-[state=open]:rotate-180",
          )}
        />
      </span>
    </CollapsibleTrigger>
    <CollapsibleContent className="border-t border-border p-2">
      <GameFilterPills
        groupId={group.id}
        options={group.options}
        selected={group.selected}
        clearable={group.clearable}
        onSelect={onSelect}
      />
    </CollapsibleContent>
  </Collapsible>
);

export default GameFilterGroup;
